import { TooltippedSpan } from '@mews-commander/ui';
import { UseResourceCategoryNameParams, useResourceCategoryName } from './useResourceCategoryName';

interface ResourceCategoryNameProps extends UseResourceCategoryNameParams {
    short?: boolean;
}

export const ResourceCategoryName = ({ resourceId, short }: ResourceCategoryNameProps) => {
    const { resourceCategoryName, resourceCategoryShortName } = useResourceCategoryName({ resourceId });

    if (!short) {
        return resourceCategoryName ? <>{resourceCategoryName}</> : null;
    }

    if (!resourceCategoryName) {
        return resourceCategoryShortName ? <>{resourceCategoryShortName}</> : null;
    }

    return resourceCategoryShortName ? (
        <TooltippedSpan tooltip={resourceCategoryName}>{resourceCategoryShortName}</TooltippedSpan>
    ) : null;
};
